import React, {useState} from "react";
import {Dropdown, Icon, Menu} from "antd";
import {
    Link,
    useLocation,
} from "react-router-dom";

import {
    ACCOUNTANT_LEGAL_ENTITY_APPROVE,
    CREATE_CROSS_DOCK,
    CREATE_DELIVERY,
    CREATE_UNLOADING,
    LAWYER_LEGAL_ENTITY_APPROVE,
    UPLOAD_ADD_PARAMS_ON_LOADING_DELIVERY,
} from "../../helpers/user_permission.helper";
import CreateDeliveryModal from "../modals/create-delivery";
import CreateCrossDockModal from "../modals/create-cross-dock";
import ModalListLoadingSchedule from "../modals/list-loading-shedule";
import ModalCreateUnLoading from "../modals/create-unloading";
import i18n from "../../i18n";


const AutoParkLink = ({user}) => {
    if (
        user.info.userType !== "carrier" ||
        !user.info.company ||
        user.info.company.type === "Новая компания"
    ) {
        return null;
    }

    return (
        <li>
            <Link to="/company/car-park">
                {i18n.t("main.header.submenu.carPark")}
            </Link>
        </li>
    );
};

const LoadingListLink = ({
                             showModalLoadingList,
                             setShowModalLoadingList,
                         }) => (
    <li>
        <Link
            to="#"
            onClick={(event) => {
                event.preventDefault();
                setShowModalLoadingList(true);
            }}
        >
            {i18n.t("main.header.submenu.onLoadSchedule")}
        </Link>

        <ModalListLoadingSchedule
            onCloseModal={setShowModalLoadingList}
            isShow={showModalLoadingList}
        />
    </li>
);

const UnLoadingCreateLink = ({
                                 showModalCreateUnLoading,
                                 setShowModalCreateUnLoading,
                             }) => (
    <li>
        <Link
            to="#"
            onClick={(event) => {
                event.preventDefault();
                setShowModalCreateUnLoading(true);
            }}
        >
            {i18n.t("main.header.submenu.createUnloading")}

            <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M10.2923 5.54134H8.70899V8.70801H5.54232V10.2913H8.70899V13.458H10.2923V10.2913H13.459V8.70801H10.2923V5.54134ZM9.50065 1.58301C5.13065 1.58301 1.58398 5.12967 1.58398 9.49968C1.58398 13.8697 5.13065 17.4163 9.50065 17.4163C13.8707 17.4163 17.4173 13.8697 17.4173 9.49968C17.4173 5.12967 13.8707 1.58301 9.50065 1.58301ZM9.50065 15.833C6.0094 15.833 3.16732 12.9909 3.16732 9.49968C3.16732 6.00843 6.0094 3.16634 9.50065 3.16634C12.9919 3.16634 15.834 6.00843 15.834 9.49968C15.834 12.9909 12.9919 15.833 9.50065 15.833Z"
                    fill="#1CAA53"
                />
            </svg>
        </Link>

        <ModalCreateUnLoading
            onCloseModal={setShowModalCreateUnLoading}
            isShow={showModalCreateUnLoading}
        />
    </li>
);

const InstructionLink = () => {
    const {pathname} = useLocation();

    const isActive = (
        pathname === "/service" ||
        pathname.startsWith("/service/")
    );

    return (
        <li className={isActive ? "active" : ""}>
            <Link to="/service/instruction">
                {i18n.t("main.header.submenu.instruction")}
            </Link>
        </li>
    );
};

export default function SubMenu({user, children}) {
    const [showModalCreateDelivery, setShowModalCreateDelivery] = useState(false);
    const [showModalLoadingList, setShowModalLoadingList] = useState(false);
    const [showModalCreateUnLoading, setShowModalCreateUnLoading] = useState(false);
    const [showModalCreateCrossDock, setShowModalCreateCrossDock] = useState(false);
    const [isMobileCreateOpen, setMobileCreateOpen] = useState(false);
    const additionalItems = React.Children.toArray(children);

    if (
        !user ||
        user.isGuest() ||
        user.isAccessTo(LAWYER_LEGAL_ENTITY_APPROVE) ||
        user.isAccessTo(ACCOUNTANT_LEGAL_ENTITY_APPROVE)
    ) {
        return (
            <ul>
                <InstructionLink/>
                {additionalItems}
            </ul>
        );
    }

    const canCreateDelivery = Boolean(
        user.info.userType === "inner" &&
        user.isAccessTo(CREATE_DELIVERY)
    );

    const canCreateCrossDock = Boolean(
        user.info.userType === "inner" &&
        user.isAccessTo(CREATE_CROSS_DOCK)
    );

    const hasCreateActions = Boolean(
        canCreateDelivery || canCreateCrossDock
    );

    const createActionsMenu = (
        <Menu className="header-dropdown-menu create-actions-menu">
            {canCreateDelivery && (
                <Menu.Item key="delivery">
                    <button
                        type="button"
                        className="create-actions-menu__button"
                        onClick={() => setShowModalCreateDelivery(true)}
                    >
                        {i18n.t("main.header.submenu.delivery")}
                    </button>
                </Menu.Item>
            )}

            {canCreateCrossDock && (
                <Menu.Item key="cross-dock">
                    <button
                        type="button"
                        className="create-actions-menu__button"
                        onClick={() => setShowModalCreateCrossDock(true)}
                    >
                        {i18n.t("main.header.submenu.crossDockRequest")}
                    </button>
                </Menu.Item>
            )}
        </Menu>
    );

    const handleMobileCreateAction = (action) => {
        setMobileCreateOpen(false);
        action();
    };

    return (
        <React.Fragment>
            <ul>
                {hasCreateActions && (
                    <li className="submenu-create submenu-create--desktop">
                        <Dropdown
                            overlay={createActionsMenu}
                            trigger={["hover", "click"]}
                            placement="bottomLeft"
                        >
                            <button
                                type="button"
                                className="submenu-create__trigger"
                                aria-haspopup="menu"
                            >
                                <span>{i18n.t("main.header.submenu.create")}</span>

                                <Icon
                                    type="down"
                                    className="submenu-create__arrow"
                                />
                            </button>
                        </Dropdown>
                    </li>
                )}

                {hasCreateActions && (
                    <li
                        className={`submenu-create submenu-create--mobile${
                            isMobileCreateOpen ? " open" : ""
                        }`}
                    >
                        <button
                            type="button"
                            className="submenu-create__mobile-trigger"
                            onClick={() =>
                                setMobileCreateOpen(!isMobileCreateOpen)
                            }
                            aria-expanded={isMobileCreateOpen}
                        >
                            <span>{i18n.t("main.header.submenu.create")}</span>

                            <Icon
                                type={isMobileCreateOpen ? "up" : "down"}
                                className="submenu-create__arrow"
                            />
                        </button>

                        {isMobileCreateOpen && (
                            <div className="submenu-create__mobile-actions">
                                {canCreateDelivery && (
                                    <button
                                        type="button"
                                        className="submenu-create__mobile-action"
                                        onClick={() =>
                                            handleMobileCreateAction(() =>
                                                setShowModalCreateDelivery(true)
                                            )
                                        }
                                    >
                                        {i18n.t("main.header.submenu.delivery")}
                                    </button>
                                )}

                                {canCreateCrossDock && (
                                    <button
                                        type="button"
                                        className="submenu-create__mobile-action"
                                        onClick={() =>
                                            handleMobileCreateAction(() =>
                                                setShowModalCreateCrossDock(true)
                                            )
                                        }
                                    >
                                        {i18n.t(
                                            "main.header.submenu.crossDockRequest"
                                        )}
                                    </button>
                                )}
                            </div>
                        )}
                    </li>
                )}

                {Boolean(
                    user.isAccessTo(CREATE_UNLOADING) ||
                    user.info.role === "buyer"
                ) && (
                    <UnLoadingCreateLink
                        setShowModalCreateUnLoading={
                            setShowModalCreateUnLoading
                        }
                        showModalCreateUnLoading={
                            showModalCreateUnLoading
                        }
                    />
                )}

                {Boolean(
                    user.info.role === "warehouse_worker" ||
                    user.isAccessTo(
                        UPLOAD_ADD_PARAMS_ON_LOADING_DELIVERY
                    )
                ) && (
                    <LoadingListLink
                        setShowModalLoadingList={setShowModalLoadingList}
                        showModalLoadingList={showModalLoadingList}
                    />
                )}

                <AutoParkLink user={user}/>

                <InstructionLink/>

                {additionalItems}
            </ul>

            {canCreateDelivery && (
                <CreateDeliveryModal
                    isShow={showModalCreateDelivery}
                    setIsShow={setShowModalCreateDelivery}
                />
            )}

            {canCreateCrossDock && (
                <CreateCrossDockModal
                    isShow={showModalCreateCrossDock}
                    setIsShow={setShowModalCreateCrossDock}
                />
            )}
        </React.Fragment>
    );
}